import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import CustomTextField from "./CustomTextField";
import Grid from "@material-ui/core/Grid";
import BorderColorIcon from "@material-ui/icons/BorderColor";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    formSubtitle: {
        fontSize: 14,
        fontWeight: 600,
        color: '#3F51B5',
        paddingBottom: theme.spacing(2),
    },
    tabPanel: {
        marginBottom: 1,
    },
    tabs: {
        fontWeight: 600,
    },
}));

export default function ScrollableTabsButtonAuto({annualAllowances, handleALChange}) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const switchTab = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <AppBar position="static" color="default" className={classes.tabPanel}>
                <Tabs
                    value={value}
                    onChange={switchTab}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                >
                    {annualAllowances.map(function (annualAllowance, i) {
                        return (
                            <Tab key={i} label={annualAllowance.year} {...a11yProps(i)} className={classes.tabs} />
                        )
                    })}

                </Tabs>
            </AppBar>
            {annualAllowances.map(function (annualAllowance, i) {
                return (
                    <TabPanel value={value} index={i} key={i}>
                        <Grid container spacing={1}>
                            <CustomTextField
                                label={'Entitled'}
                                name={'total'}
                                values={annualAllowance.total}
                                handleChange={(e) => handleALChange(i, e)}
                                type={'number'}
                                validators={['required']}
                                space={6}
                                readonly={false}
                            />
                            <CustomTextField
                                label={'Taken'}
                                name={'taken'}
                                values={annualAllowance.taken}
                                handleChange={(e) => handleALChange(i, e)}
                                type={'number'}
                                validators={['required']}
                                space={6}
                                readonly={false}
                            />
                            <CustomTextField
                                label={'Balance'}
                                name={'balance'}
                                values={Number(annualAllowance.total) - Number(annualAllowance.taken)}
                                handleChange={(e) => handleALChange(i, e)}
                                type={'number'}
                                validators={[]}
                                space={6}
                                readonly={true}
                            />
                            <CustomTextField
                                label={'Full Year Entitlement'}
                                name={'yearly_entitlement'}
                                values={annualAllowance.yearly_entitlement}
                                handleChange={(e) => handleALChange(i, e)}
                                type={'number'}
                                validators={['required']}
                                space={6}
                                readonly={false}
                            />
                            <Grid item xs={12}>
                                <Typography variant="h5" component="h2" className={classes.formSubtitle}>
                                    SH Annual Leave
                                </Typography>
                            </Grid>
                            <CustomTextField
                                label={'Entitled'}
                                name={'gov_leave_total'}
                                values={annualAllowance.gov_leave_total}
                                handleChange={(e) => handleALChange(i, e)}
                                type={'number'}
                                validators={['required']}
                                space={6}
                                readonly={false}
                            />
                            <CustomTextField
                                label={'Balance'}
                                name={'gov_leave_balance'}
                                values={annualAllowance.gov_leave_balance}
                                handleChange={(e) => handleALChange(i, e)}
                                type={'number'}
                                validators={['required']}
                                space={6}
                                readonly={false}
                            />
                            <Grid item xs={12}><Box component="span" m={1}/></Grid>
                            <CustomTextField
                                label={'Expiry Date'}
                                name={'expiry_date'}
                                values={annualAllowance.expiry_date}
                                handleChange={(e) => handleALChange(i, e)}
                                type={'date'}
                                validators={['required']}
                                space={6}
                                readonly={false}
                            />
                            <CustomTextField
                                label={'Effective Date'}
                                name={'effective_date'}
                                values={annualAllowance.effective_date}
                                handleChange={(e) => handleALChange(i, e)}
                                type={'string'}
                                validators={[]}
                                space={6}
                                readonly={true}
                            />
                        </Grid>
                    </TabPanel>
                )
            })}
        </div>
    );
}
